import { Badge } from '@civilgrid/ui/components';

interface ExceedsLimitWarningProps {
  store: any;
  exceeds: boolean;
}

export default function ({ store, exceeds }: ExceedsLimitWarningProps) {
  if (exceeds === false) {
    return null;
  }

  if (!store?.projectAreaLimit) {
    console.warn('Incorrect "Store" type, must have "projectAreaLimit" property and property must be defined.');
    return null;
  }

  return (
    <Badge color="red" className="my-2 px-4 py-2 text-base">
      Project cannot be greater than {store.projectAreaLimit} acres.
    </Badge>
  );
}
